import React from "react";
import { Box, SxProps } from "@mui/material";

interface Props {
  sx?: SxProps;
}

const Shape: React.FC<Props> = ({ sx }) => {
  return (
    <Box sx={sx}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 200 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="currentColor"
          d="M62,-62.9C77.5,-46.5,85.1,-23.3,84.1,-1C83,21.2,73.3,42.4,57.8,58.5C42.4,74.7,21.2,85.9,-0.3,86.1C-21.7,86.4,-43.4,75.8,-58,59.6C-72.7,43.4,-80.2,21.7,-79,1.2C-77.8,-19.3,-67.9,-38.6,-53.2,-55C-38.6,-71.4,-19.3,-85,2,-87C23.3,-89,46.5,-79.4,62,-62.9Z"
          transform="translate(100 100)"
        />
      </svg>
    </Box>
  );
};

export default Shape;
